

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>


<div class="row" data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
        <div style="
        margin: 0 auto;
        float: none;
        margin-bottom: 10px;
        background-color: #eff8ff;" class="card w-65">
        <div class="card-body">
            <h2 style="text-align: center;font-size: 550;color: black;">How can Businesses Verify MSME Merchants Online</h2>
        </div>
        </div>
    </div>
</div>
<br>
<div class="row p-3" data-aos="fade-up" data-aos-delay="300">
    <div class="col">
        <h2 style="color: #6ab187;text-align: center;">Introduction</h2>

        <p style="text-align: center;">Navigating the verification landscape for Micro, Small, and Medium Enterprises (MSMEs) in India presents its <br>own set of challenges. Businesses frequently find it difficult to determine the legitimacy of their partner <br>companies because of the constantly changing regulatory landscape. The Udyam Verification API emerges as a<br> transformative solution designed to simplify and streamline the MSME verification process.</p>
        
        <p style="text-align: center;">A unique identifying number called a “Udyam Aadhaar“ (formerly called Udyog Aadhaar) is given to Micro, <br>Small, and Medium-Sized Enterprises (MSMEs) in India as part of the Udyam Registration procedure. The Udyam <br>Aadhaar, a 12-digit identifying number, is used as registration documents for MSMEs.</p>
    </div>
</div>


<!--  -->
<br><br>

<div class="row" data-aos="fade-up" data-aos-delay="300">
    <div class="col">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">Why is it Necessary : </h2><br>
    </div>
    </div>
    <div class="row p-3  ">

      <div data-aos="fade-up" data-aos-delay="300" class="col-md-3 text-center ">
        <br>
        <div style=" width: 200px;
        height: 200px;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        background: lightblue;margin-left: 25%;" >
          <h3 ><br>Regulatory <br>& Legal Compliance</h3>

        </div>
      </div>
      <div data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
          <h3 style=" width: 200px;
          height: 200px;
          border-radius: 50%;
          color: #fff;
          text-align: center;
          background: lightblue;margin-left: 25%;"><br><br>Fraud Prevention</h3>
      </div>
      
      <div data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
          <h3 style=" width: 200px;
          height: 200px;
          border-radius: 50%;
          color: #fff;
          text-align: center;
          background: lightblue;margin-left: 25%;"><br><br>Efficient Verification</h3>
      </div>
       
     
      <div data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
          <h3 style=" width: 200px;
          height: 200px;
          border-radius: 50%;
          color: #fff;
          text-align: center;
          background: lightblue;margin-left: 25%;"><br><br>Secure Transactions</h3>
      </div>
    </div>
     



<div class="row p-3">
  <h2 data-aos="fade-up" data-aos-delay="300" style="text-align: center;color: #6ab187;">How Does Udyam Verification API Enable Secure<br> Business Collaboration?</h2>
  <div class="col-md-3"></div>
<div class="col-md-6" data-aos="fade-up" data-aos-delay="300"   >
  <p >Firms can seamlessly integrate Udyam Aadhaar verification API into several procedures listed below to bolster transparency, credibility, and compliance within their collaborative ventures.</p>

  <h6 ><img style="width: 30px;height:30px;border-radius: 15px;" src="assets/handlogo.png">  <strong style="color: black;"> Digital Lending</strong> - In banking, finance, and retail, verifying companies or entities with a high risk of fraud becomes crucial.<br> Lending institutions can evaluate an enterprise’s authenticity and lower the risk of financial and reputational harm by using<br> Udyam certificate verification </h6><br>
  
  <h6 ><img style="width: 30px;height:30px;border-radius: 15px;" src="assets/handlogo.png">  <strong style="color: black;"> Vendor Selection </strong> - Businesses can ensure they are working with reliable vendors by verifying the Udyam registration of their<br> suppliers and vendors. This verification improves supply chain transparency and reduces the danger of working with unregistered<br> or fraudulent vendors.</h6><br>

  <h6  ><img style="width: 30px;height:30px;border-radius: 15px;" src="assets/handlogo.png">  <strong style="color: black;"> Partnership Due Diligence </strong> - Companies can confirm the legitimacy of their potential business partners before getting into<br> business with them using Udyam Aadhaar verification. This minimizes the danger of fraudulent operations by ensuring they interact<br> with registered and compliant organizations. </h6><br>

  <h6  ><img style="width: 30px;height:30px;border-radius: 15px;" src="assets/handlogo.png"> <strong style="color: black;"> Contractual Agreements </strong> - Businesses can incorporate Udyam Aadhaar verification for contract-based collaborations to provide such<br> partnerships an additional level of assurance, combined with legal compliance.</h6><br>

  <h6  ><img style="width: 30px;height:30px;border-radius: 15px;" src="assets/handlogo.png">  <strong style="color: black;"> Merchant Onboarding </strong> - Enterprises can be assured they are onboarding reliable merchants or business partners who would not cause<br> unforeseen risks or threats in the future by incorporating Udyam Aadhaar verification.</h6>                                                                                   
</div>
<div class="col-md-3"></div>
</div>


<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
        <br><br>
        <h2 style="text-align: center;color: #6ab187;">How Does It Work?</h2>
        <br>
       
      
        </div>
    </div>
    <div  class="row p-2"  data-aos="fade-up" data-aos-delay="300"  >
  
      <div style="background-color: rgb(198, 226, 235)"   class="col-md-3">
          <br>
         
          <h5>STEP 1</h5>
          <p style="align-items: center;"> Enter the name of the enterprise</p>
      </div>
    
      <div class="col-md-3">
            <br>
          
            <h5 >STEP 2</h5>
            <p style="align-items: center;">Registration date or date of commencement of the firm</p>
        </div>
       
        <div style="background-color: rgb(198, 226, 235)" class="col-md-3">
       
          <br>
          
          <h5 >STEP 3</h5>
          <p style="align-items: center;">Status and Major activity of the enterprise<p>
      </div>
    
        
      <div class="col-md-3">
        <br>
        <h5 >STEP 4</h5>
        <p style="align-items: center;">Location (State & District) where the firm<p>
    </div>
  
    </div>

    <div class="row p-3 mt-4" data-aos="zoom-in" data-aos-delay="300">
        <div class="col">
            <h3 style="text-align:center;color: gray;">Here’s how the Udyam verification API works:</h3>
            <br>
            <p ><strong>1. Collect the MSME’s Udyam Aadhaar Number: </strong>Businesses need to enter the Udyam Aadhaar number of the<br> merchant or company they want to verify.It is a 12-digit number unique to each MSME and, when entered, initiates <br>the verification process. The Udyam number will be available on the Udyam certificate or Udyam aadhaar<br> memorandum of the merchant. </p>
            <br>
            
            <p ><strong>2. Verify the Company Using the API:</strong>The Udyam verification API verifies the merchant by validating the Udyam<br> Aadhaar number. The API validates all the business data linked to the Udyam Aadhaar Number to validate the MSME.</p>
            <br>

            <p ><strong>3. Access Verified Company Details: </strong>The Udyam verification API returns essential data of the MSME, such as the<br> company’s name, date of establishment, status, primary activity, location, and other details associated with the MSME<br> to help businesses establish secure and risk-free partnerships. </p>
            <br>

        </div>
    </div>


    <div class="row p-3" data-aos="zoom-in" data-aos-delay="300">
        <div class="col">
            <h3 style="text-align: center;color: #6ab187;">How Does Udyam Verification API Benefit Businesses?</h3>
            <p style="">The Udyam Verification API offers various benefits for firms when they are verifying the legitimacy of <br>an MSME partner business. In addition to digitizing the verification workflow, the API also provides an<br> array of other key advantages:</p>

            <p ><strong>1. Expedited Onboarding: </strong>Businesses can decrease the time spent on manual verification processes and speed up<br> onboarding journeys by using the API. Enterprises can easily onboard MSME-compliant enterprises to their platform<br> by pre-filling verified business details linked to the Udyam Aadhaar number.</p>
            <br>

            <p ><strong>2. Tackles Fraud at the Root: </strong>Businesses can weed out fake MSME merchants from the very start of their partnership<br> process with the help of the Udyam Aadhaar Verification API, which verifies the legality of MSME merchants online.</p>
            <br>

            <p ><strong>3. Automated Verification: </strong>Utilizing the Udyam Verification API has the additional benefit of streamlining and simplifying<br> authentication processes. The API can automate the approval of verified merchants, cutting down on the time required for<br> manual assessments.</p>
            <br>

            <p ><strong>4. Seamless Integration: </strong>For companies wishing to improve their merchant onboarding procedures, the Udyam Aadhaar<br> Verification API provides a ready-to-use solution that has been optimized to incorporate into existing digital platforms <br>and systems smoothly.</p>
            <br>

            <p ><strong>5. Human Error Prevention: </strong>: Manual form-filling to initiate verification can result in mistakes, which can have severe<br> ramifications for organizations. Businesses can save time on manual procedures, avoid errors, reduce operational costs, and<br> improve efficiency by utilizing the Udyam Aadhaar Verification API.</p>
            <br>
        </div>
    </div>



  <div class="row" data-aos="zoom-in" data-aos-delay="300"   >
    <div class="col">
      <br><br><br>
      <!-- Footer -->
      <footer class="text-center text-lg-start text-white" style="background-color: #1c2331">
        <!-- Section: Social media -->
        <section class="d-flex justify-content-between p-4" style="background-color: #6ab187">
          <!-- Left -->
          <div class="me-5">
            <span>Get connected with us on social networks:</span>
          </div>
          <!-- Left -->
  
          <!-- Right -->
          <div>
  
            <a href="" class="text-white me-5">
              <i class="fab fa-instagram"></i>
            </a>
  
  
          </div>
          <!-- Right -->
        </section>
        <!-- Section: Social media -->
  
  
        <section data-aos="zoom-in" data-aos-delay="300" class="p-4">
          <div class="text-center text-md-start mt-5">
  
            <div class="row">
  
              <div class="col-md-4 ">
                <!-- Content -->
  
                <h6 style="margin-right: 74%;font-size:16px" class="text-uppercase fw-bold"><img
                    style="width: 27px;height: auto;border-radius: 40%;" src="assets/handlogo.png"> FACheck</h6>
  
                <p style="text-align: justify;
    text-justify: inter-word">
                  Facheck is a very useful product in the Finance,Banking, and growing Industries in India. It checks &
                  authenticates the Person / Company document and reveals the result with the validity and truth of the
                  document. So, with the help of the Facheck - verification you can process the proper document and
                  avoid fraudulent disclosures. It help your organization to proceed further with Fact-Check of your
                  clients.
                </p>
              </div>
  
  
              <div class="col-md-2">
                <!-- Links -->
                <h6 class="text-uppercase fw-bold" >Solutions</h6>
  
                <p>
                  <a href="bluecollar"  class="text-white">Blue-collar
                    verify</a>
                </p>
                <p>
                  <a href="distribute"  class="text-white">Distributor
                    Onboard</a>
                </p>
                <p>
  
                  <a href="duediligence"  class="text-white">Due
                    Diligence</a>
                </p>
                <p>
  
                  <a href="gigworker"  class="text-white">Gig Worker
                    Verify</a>
  
                </p>
                <p>
  
                  <a href="kycsolution"  class="text-white">KYC
                    Solutions</a>
                </p>
                <p>
                  <a href="riskmanage"  class="text-white">Risk Manage</a>
                </p>
                <p>
  
                  <a href="vendor"  class="text-white">Vendor Onboard</a>
                </p>
                <p>
  
                  <a href="whitecollar"  class="text-white">White-collar
                    verify</a>
                </p>
              </div>
  
  
              <div  class="col-md-2 text-align">
  
                <h6 class="text-uppercase fw-bold" >Products</h6>
  
                <p>
                  <a href="aadhaar"  class="text-white">Aadhaar verify</a>
                </p>
                <p>
                  <a href="cinverify"  class="text-white">CIN verify</a>
                </p>
                <p>
                  <a href="dinverify"  class="text-white">DIN verify</a>
                </p>
                <p>
                  <a href="driving"  class="text-white">Driving License</a>
                </p>
                <p>
                  <a href="gst"  class="text-white">GST verify</a>
                </p>
                <p>
                  <a  href="msmeverify" class="text-white">MSME verify</a>
                </p>
                <p>
                  <a href="pan"  class="text-white">PAN verify</a>
                </p>
                <p>
                  <a href="passport"  class="text-white">Passport verify</a>
                </p>
                <p>
                  <a href="rcverify"  class="text-white">RC verify</a>
                </p>
  
                <br><br><br>
              </div>
  
  
  
  
              <div  class="col-md-4 text-center">
  
                <h6  class="text-uppercase fw-bold">Quick links</h6>
  
  
                <a  href="privacypolicy">Privacy Policy</a>
                <br><br>
                <a  href="termscondition">Terms & Condition</a>
                <br><br>
  
                <a  href="refundpolicy">Refund Policy</a>
                <br><br>
                <!-- Links -->
                <h6 class="text-uppercase fw-bold">Contact</h6>
  
  
                <p >support@facheck.in &nbsp;<i
                    class="fas fa-envelope mr"></i> </p>
  
                <p  class=" text-center ">Registered Head Office <i class="fas fa-home"></i>
                  <br>New 9, Old # 11, Ground Floor,
                  Palayakaran Street, Kalaimagal Nagar, Ekkaduthangal, Chennai
                </p>
  
              </div>
  
  
            
  
  
            </div>
            <!-- Grid row -->
  
  
          </div>
        </section>
        <br>
        <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
          Copyright© 2023. Powered by
          <a class="text-white" href="#">facheck.com
            | All Rights Reserved </a>
        </div>
  
      </footer>
      <!-- Footer -->
  
    </div>
  </div>
  
  